import { render, staticRenderFns } from "./appointText.vue?vue&type=template&id=7f67e5dc&scoped=true"
import script from "./appointText.vue?vue&type=script&lang=js"
export * from "./appointText.vue?vue&type=script&lang=js"
import style0 from "./appointText.vue?vue&type=style&index=0&id=7f67e5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f67e5dc",
  null
  
)

export default component.exports